import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.transactionLog],
        config: {
            headerName: getLocalizedString("internalCode"),
            field: "internalCode",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.transactionLog],
        config: {
            field: "Código de usuario",
            headerName: getLocalizedString("userCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.transactionLog],
        config: {
            field: "Nombre del usuario",
            headerName: getLocalizedString("userName"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.transactionLog],
        config: {
            field: "Fecha de ejecución",
            headerName: getLocalizedString("executionDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.transactionLog],
        config: {
            field: "Hora de ejecución",
            headerName: getLocalizedString("executionTime"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.transactionLog],
        config: {
            field: "Sentencias de SQL",
            headerName: getLocalizedString("sqlStatements"),
            filter: "agTextColumnFilter",
        }
    },
]